import { Protected } from "@stardeck-customer-apps/project-auth";
import { BrowserRouter as Router, Outlet, Route, Routes } from "react-router-dom";

import AdminDashboard from "@/pages/admin/admin-dashboard";
import AdminLogin from "@/pages/admin/admin-login";
import UserDashboard from "@/pages/dashboard/user-dashboard";
import DbTestPage from "@/pages/db-test";
import { Home } from "@/pages/home";
import Login from "@/pages/login";
import { NotFound } from "@/pages/not-found";
import { Unauthorized } from "@/pages/unauthorized";
import { Providers } from "@/providers";

function AppRoutes() {
  return (
    <Router>
      <Providers>
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/db-test" element={<DbTestPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <Protected requiredPermission="deployment:admin-panel:write">
                  <Outlet />
                </Protected>
              }
            >
              <Route path="" element={<AdminDashboard />} />
            </Route>
            <Route
              path="/dashboard"
              element={
                <Protected requiredPermission="deployment:user:write">
                  <Outlet />
                </Protected>
              }
            >
              <Route path="" element={<UserDashboard />} />
            </Route>
            <Route path="/unauthorized" element={<Unauthorized />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
      </Providers>
    </Router>
  );
}

export default AppRoutes;
